import {Component, Input, OnInit} from '@angular/core';
import {ViewCell} from 'ng2-smart-table';
import {TranslateService} from '@ngx-translate/core';

@Component({
    template: `
        <a [ngClass]="'table-cell-link'" [routerLink]="[this.path, rowData.siteId]">{{renderValue}}</a>
  `
})

export class SiteUrlCellRenderComponent implements OnInit, ViewCell {

    renderValue: string;

    @Input()
    value: string;
    @Input()
    rowData: any;

    path: string;

    constructor(private translateService: TranslateService) {
        this.path = this.translateService.currentLang !== undefined ? '/' + this.translateService.currentLang + '/site' : '/site';
    }

    ngOnInit(): void {
        this.renderValue = this.value;
    }

}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/sites/sites-table/site-url-cell-render.component.ts